import { useShallow } from "zustand/react/shallow";

import { Page } from "@components/atoms/page";
import { useTableParams } from "@components/organisms/pageTable";
import { Statistics } from "@components/organisms/statistics";
import { useDownloadReport, useSetFilter } from "@hooks";
import { useGetAllMedicalServiceAppointments } from "@api/msp/appointments/getAll";
import { AppointmentMspList } from "@/templates/appointmentMspList";
import { useUserStore } from "@/stores/userStore";
import type { IRole } from "@/interfaces";
import type { IMspVariants } from "@components/organisms/appointmentCard/components/appointmentCardBottom";

export function Component() {
  const {
    paginationValues,
    searchValue,
    filterValues,
    tableProps,
    setFilters,
  } = useTableParams({});
  const { currentPage, resultsPerPage } = paginationValues;

  const role = useUserStore(useShallow((state) => state.role));

  const variables = {
    page: currentPage,
    per_page: resultsPerPage,
    filter: searchValue,
    ...filterValues,
  };

  const { data, isLoading, isFetching, isError } =
    useGetAllMedicalServiceAppointments({
      variables,
    });

  const { onDownload, onPrint } = useDownloadReport(
    "medicalServiceProvider",
    variables,
  );

  useSetFilter({ filters: data?.data?.data?.filters, setFilters });

  const stats = data?.data?.data?.statistics;

  return (
    <Page>
      <Statistics data={stats || []} isLoading={isLoading} isError={isError} />
      <AppointmentMspList
        data={
          data?.data?.data?.page?.list?.map((item) => ({
            ...item,
            status: item?.is_attended ? "performed" : "un-performed",
          })) || []
        }
        total={data?.data?.data?.page?.total || 0}
        isLoading={isLoading}
        isFetching={isFetching}
        tableParamProps={tableProps}
        isError={isError}
        onDownload={onDownload}
        onPrint={onPrint}
        cardVariant={getCardVariant(role)}
      />
    </Page>
  );
}

const getCardVariant = (role: IRole | null): IMspVariants => {
  if (role === "medical-service-provider-drug") return "msp_prescription";
  if (role === "medical-service-provider-lab") return "msp_order";
  return "msp_image";
};
